(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-livraison"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mm-free-delivery'))customElements.define('mm-free-delivery',class extends HTMLElement{
connectedCallback(){this.sync=()=>{const counter=document.querySelector('.cart-count');const value=counter?counter.textContent.trim():'';const count=value==='~'?101:(counter?parseInt(value.replace(/[^0-9]/g,''),10):Number(this.dataset.count));this.hidden=!(count>0);};this.sync();this.observer=new MutationObserver(records=>{if(records.some(r=>(r.target.nodeType===3?r.target.parentElement:r.target)?.nodeType===1&&((r.target.nodeType===3?r.target.parentElement:r.target).matches('.cart-count')||(r.target.nodeType===3?r.target.parentElement:r.target).closest('.cart-count')||Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches('.cart-count')||n.querySelector('.cart-count'))))))this.sync();});this.observer.observe(document.body,{childList:true,characterData:true,subtree:true});}
disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

})();
